<template>
  <div class="user-panel-wrapper">
    <Meta>
      <UserAvatar slot="avatar" :user-avatar="user.avatar" />
      <div slot="title" class="info-title">{{ user.name }}</div>
      <div slot="description" class="info-subtitle">
        <span v-if="user.orgList">{{ user.orgList.join("|") }}</span>
      </div>
    </Meta>
    <div class="info-item" v-if="user.mobile">
      <div class="info-field">{{$t('addressBook.Phone')}}</div>
      <div class="info-content">{{ user.mobile }}</div>
    </div>
    <div class="info-item" v-if="user.corpName">
      <div class="info-field">{{$t('personSetting.Company')}}</div>
      <div class="info-content">{{ user.corpName }}</div>
    </div>
    <div class="info-item" v-if="user.email">
      <div class="info-field">{{$t('addressBook.Mail')}}</div>
      <div class="info-content">{{ user.email }}</div>
    </div>
  </div>
</template>
<script>
import { List } from 'ant-design-vue'
import UserAvatar from '@/components/business/avatar/UserAvatar.vue'

// 用户面板 - 可以结合Card组件
export default {
  name: 'UserPanel',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  components: {
    UserAvatar,
    Meta: List.Item.Meta
  },
  created() {
    console.error(this.user)
  }
}
</script>
<style lang="less" scoped>
@import url(~@/styles/font.less);
.user-panel-wrapper {
  ::v-deep .ant-list-item-meta {
    display: flex;
    align-items: center;
    margin-bottom: 28px;
    &-avatar {
      margin-right: 24px;
      flex-shrink: 0;
      & > img {
        width: 88px;
        height: 88px;
        border-radius: 16px;
        margin-right: 8px;
      }
    }
    & > .content {
      display: table;
      flex-wrap: 1;
    }
    &-title {
      .medium-font(28);
      margin-bottom: 8px;
      line-height: normal;
    }
    &-description {
      .regular-font(16);
      color: #6a6d73;
    }
  }
  .info-item {
    .regular-font(16);
    color: #333;
    display: flex;
    flex-direction: row;
    height: 22px;
    line-height: 22px;

    & + .info-item {
      margin-top: 16px;
    }

    & > .info-field {
      flex-shrink: 0;
      width: 64px;
    }
    & > .info-content {
      flex-grow: 1;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
</style>
